import { InjectionToken } from '@angular/core';
import { EqaFocusableElementAccessor } from '@shared/domain/interfaces/focusable-element-accessor';

export const EQA_FOCUSABLE_ITEM_ACCESSOR = new InjectionToken<EqaFocusableElementAccessor>(
	'A component that can be focused',
);
